/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Type of download rights
 */
export enum UserDownloadRights {
  HR = 'HR',
  ORIGINAL = 'ORIGINAL',
  BOTH = 'BOTH',
  NONE = 'NONE',
}
